import React, { useEffect, useState } from 'react'
import DonorNeedCard from './DonorNeedCard/DonorNeedCard';
import EventCard from './EventCard/EventCard';
import BloodStationNeedCard from './BloodStationNeedCard/BloodStationNeedCard';
import ChooseCityCard from './ChooseCityCard/ChooseCityCard';
import JournalCard from './JournalCard/JournalCard';
import { inject, observer } from 'mobx-react';
import styles from './Event.module.scss'

const Event = ({
  randomActivitiesStore,
  // eventStore,
  // recipientStore,
  // bloodStationsNeedStore
}) => {

  const [loader, setLoader] = useState(true)
  const [activityData, setActivityData] = useState(null)
  const [cardType, setCardType] = useState(null)

  // const [donorNeedData, setDonorNeedData] = useState(null)
  // const [eventData, setEventData] = useState(null)
  // const [bloodStationNeedData, setBloodStationNeedData] = useState(null)

  const getActivityData = () => {
    setLoader(true)
    randomActivitiesStore.getRandomCards()
      .then((data: any) => {
        setActivityData(data)
      })
  }

  useEffect(() => {
    getActivityData()
    // eventStore.initEvent(558)
    // setEventData(eventStore.eventData)

    // recipientStore.initRecipient(5)
    // setDonorNeedData(recipientStore.recipientData)

    // bloodStationsNeedStore.loadOne(141)
    //   .then(data => {
    //     setBloodStationNeedData(data)
    //     console.log(data)
    //   })
  }, [])

  // useEffect(() => {
  //   console.log(recipientStore.recipientData)
  //   setDonorNeedData(recipientStore.recipientData)
  //   setLoader(false)
  // }, [recipientStore.recipientData])

  // useEffect(() => {
  //   setEventData(eventStore.eventData)
  // }, [eventStore.eventData])

  useEffect(() => {
    // console.log(activityData)
    activityData?.message === 'set_city'
    ? setLoader(false)
    : setCardType(activityData?.activity_type)
  }, [activityData])

  useEffect(() => {
    activityData?.activity_type && setLoader(false)
  }, [cardType])
  
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.content} ${!loader ? styles.show : ''}`}>
        {
          !loader && (
            activityData?.message === 'set_city'
            ? (
              <ChooseCityCard successCallback={getActivityData} />
            ) : (
              cardType === 'address_need' && (
                <DonorNeedCard data={activityData} />
              ) ||
              cardType === 'blood_station' && (
                <BloodStationNeedCard data={activityData} />
              ) ||
              cardType === 'event' && (
                <EventCard data={activityData} />
              ) ||
              cardType === 'article' && (
                <JournalCard data={activityData} />
              )
              // donorNeedData && <DonorNeedCard data={donorNeedData} />
              // bloodStationNeedData && <BloodStationNeedCard data={bloodStationNeedData} />
              // eventData && <EventCard data={eventData} />
            )
          )
        }
      </div>
    </div>
  )
}

export default inject(
  'randomActivitiesStore',
  'eventStore',
  'recipientStore',
  'bloodStationsNeedStore'
)(observer(Event));